import { combineReducers } from 'redux'
import { handleResponse } from './api/apiUtils'
import { getPropertiesUrl } from './api/urls'

export const SET_CURRENT_PROPERTY = 'SET_CURRENT_PROPERTY'
export const PROPERTIES_FETCH_REQUEST = 'PROPERTIES_FETCH_REQUEST'
export const PROPERTIES_FETCH_SUCCESS = 'PROPERTIES_FETCH_SUCCESS'
export const PROPERTIES_FETCH_FAILURE = 'PROPERTIES_FETCH_FAILURE'

const initialState = {
    current: null,
    isFetching: false,
    entities: [],
    error: null
}

const currentProperty = (state = initialState.current, action) => {
    switch (action.type) {
        case SET_CURRENT_PROPERTY:
            return action.data
        case PROPERTIES_FETCH_REQUEST:
            return state
        case PROPERTIES_FETCH_SUCCESS:
            return state
        case PROPERTIES_FETCH_FAILURE:
            return state
        default:
            return state
    }
}

const entities = (state = initialState.entities, action) => {
    switch (action.type) {
        case SET_CURRENT_PROPERTY:
            return state
        case PROPERTIES_FETCH_REQUEST:
            return state
        case PROPERTIES_FETCH_SUCCESS:
            return [...action.data]
        case PROPERTIES_FETCH_FAILURE:
            return state
        default:
            return state
    }
}

const isFetching = (state = initialState.isFetching, action) => {
    switch (action.type) {
        case SET_CURRENT_PROPERTY:
            return state
        case PROPERTIES_FETCH_REQUEST:
            return true
        case PROPERTIES_FETCH_SUCCESS:
            return false
        case PROPERTIES_FETCH_FAILURE:
            return false
        default:
            return state
    }
}

const error = (state = initialState.error, action) => {
    switch (action.type) {
        case SET_CURRENT_PROPERTY:
            return state
        case PROPERTIES_FETCH_REQUEST:
            return state
        case PROPERTIES_FETCH_SUCCESS:
            return state
        case PROPERTIES_FETCH_FAILURE:
            return action.data
        default:
            return state
    }
}

const propertiesRequest = () => ({
    type: PROPERTIES_FETCH_REQUEST
})

const propertiesFetchSuccess = data => ({
    type: PROPERTIES_FETCH_SUCCESS,
    data
})

const propertiesFetchFailure = error => ({
    type: PROPERTIES_FETCH_FAILURE,
    data: error
})

const chooseCurrentProperty = data => ({
    type: SET_CURRENT_PROPERTY,
    data
})

export const getProperties = key => (dispatch, getState) => {
    dispatch(propertiesRequest())
    fetch(getPropertiesUrl(key))
        .then(handleResponse)
        .then(json => dispatch(propertiesFetchSuccess(json)))
        .catch(error => dispatch(propertiesFetchFailure(error)))
}

export const propertiesReducer = combineReducers({
    currentProperty,
    entities,
    isFetching,
    error
})

export const setCurrentProperty = propertyId => (dispatch, getState) => {
    const { secretKey } = getState()
    dispatch(chooseCurrentProperty(propertyId))
    
}



// WEBPACK FOOTER //
// ./modules/properties.js